import React from 'react'
import Title from './title'
import DatePickerButton from './date-picker-button'
import DateFormatter from '../../../shared/helpers/date-format'
import PropTypes from 'prop-types'

import {
  BackButton,
  CurrentButton,
  NextButton,
  DayViewButton,
  WeekViewButton
} from './buttons'

const formatDate = dateRange => DateFormatter.param(dateRange.start)

// the Tickets app doesn't need all of the button nor some Calendar app styling
// it also needs to change the word on the Current button to 'Today'
function Header({
  dateRange = null,
  navigate = () => {},
  navigateRelative = () => {},
  children,
  fromTicketsApp = false
}) {
  if (!dateRange) {
    return null
  }

  let isCurrent = dateRange.isCurrent
  let isSingle = dateRange.isSingleDay()

  return (
    <div className={fromTicketsApp ? '' : 'container max-w-xl'}>
      <div
        className={
          fromTicketsApp ? 'mb-32' : 'my-32 lg:my-40 lg:flex lg:items-center'
        }
      >
        <div className="lg:flex-grow lg:pr-20">
          <Title dateRange={dateRange} />
        </div>

        <div className="mt-32 lg:mt-0 flex lg:items-center lg:flex-no-grow lg:justify-end">
          <div className="hidden md:block mr-8 my-auto">{children}</div>

          <BackButton
            disabled={isCurrent}
            onClick={() => navigateRelative(formatDate(dateRange.previous()))}
            isSingleDay={isSingle}
          />

          <CurrentButton
            disabled={isCurrent}
            onClick={() => navigateRelative(formatDate(dateRange.today()))}
            isSingleDay={fromTicketsApp || isSingle}
          />

          <NextButton
            disabled={false}
            onClick={() => navigateRelative(formatDate(dateRange.next()))}
            isSingleDay={isSingle}
          />

          <DatePickerButton
            dateRange={dateRange}
            navigate={navigate}
            fromTicketsApp={fromTicketsApp}
          />

          {!fromTicketsApp && (
            <div className="inline-flex flex-grow sm:flex-no-grow">
              <DayViewButton
                onClick={() =>
                  navigate(`/calendar/day/${formatDate(dateRange.contract())}`)
                }
                isSingleDay={isSingle}
              />

              <WeekViewButton
                onClick={() =>
                  navigate(`/calendar/week/${formatDate(dateRange.expand())}`)
                }
                isRange={dateRange.isRange()}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  dateRange: PropTypes.object,
  navigate: PropTypes.func,
  navigateRelative: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default Header
